import { App } from './App';

const app = new App(document.getElementById('root') as HTMLDivElement);
app.run();
console.log(app);



// WEBPACK FOOTER //
// ./src/index.tsx